import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import {
  SCREENS,
  assessmentGradeMapping,
} from "../../utils/CommonUtils/constants";
import useTranslationSetup from "../../utils/useTranslationSetup";
import useParamValues from "../../utils/useParamValues";
import useWebViewBridge from "../../utils/useWebViewBridge";
import CloudTopHI from "../../assets/onboarding-illustration-hi.svg";
import CloudTopEN from "../../assets/onboarding-illustration-en.svg";
import AssessmentFlow from "../../assets/assessment-flow.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import SubjectTag from "../../components/subjectTag/SubjectTag";
import CustomErrorDialogBox from "../../components/CustomErrorDialogBox/CustomErrorDialogBox";
import "./OnBoardingScreen.css";

function OnBoardingScreen({ setActiveScreen }) {
  const { t } = useTranslationSetup();
  const { classNum, subjectId, assessmentLang } = useParamValues();
  const cloudTopImg = assessmentLang === "en" ? CloudTopEN : CloudTopHI;
  const { sendMessageToReactNative } = useWebViewBridge();
  const [openIndex, setOpenIndex] = useState(null);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);

  const validGrades = assessmentGradeMapping[Number(subjectId)];
  const isUrlMismatch =
    !!validGrades && !validGrades.includes(Number(classNum));

  useEffect(() => {
    if (isUrlMismatch) {
      setErrorDialogOpen(true);
    }
  }, [isUrlMismatch]);

  const faqs = [
    { question: t("faq_question_1"), answer: t("faq_answer_1") },
    { question: t("faq_question_2"), answer: t("faq_answer_2") },
    { question: t("faq_question_3"), answer: t("faq_answer_3") },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleGoNext = () => {
    if (isUrlMismatch) {
      setErrorDialogOpen(true);
      return;
    }
    setActiveScreen(SCREENS.RENDER_NEED_PERMISSION_SCREEN);
  };

  return (
    <div>
      <div className="subject-tag-wrapper">
        <SubjectTag />
      </div>
      <div>
        <img src={cloudTopImg} alt="Clouds" className="cloud-top-img" />
      </div>

      <div className="onboarding-screen-container">
        <div className="onboarding-screen-heading-text">
          {t("onboarding_screen_1")}
        </div>
        <div className="onboarding-screen-content-wrapper">
          <div className="onboarding-screen-content-1">
            {t("onboarding_screen_2")}
          </div>
        </div>
        <div className="onboarding-screen-question">
          {t("onboarding_screen_3")}
        </div>
        <div>
          <img
            src={AssessmentFlow}
            alt="assessment_flow"
            className="assessment-flow-img"
          />
        </div>
        <div className="onboarding-screen-content-2">
          {t("onboarding_screen_4")}
        </div>
        <div className="onboarding-faq">{t("faq_question")}</div>
        <div className="faqs-container">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? "open" : ""}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <span>{faq.question}</span>
                <ExpandMoreIcon
                  className={`icon ${openIndex === index ? "rotate" : ""}`}
                />
              </div>
              {openIndex === index && (
                <div className="faq-answer">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="onboarding-sticky-button">
        <Button
          variant="contained"
          style={{
            height: "46px",
            width: "100%",
            textTransform: "none",
            borderRadius: "10px",
            color: "#FFFFFF",
            fontSize: "16px",
            fontFamily: "poppins-regular",
            background: "#A2C357",
            boxShadow: "#3B43450A",
          }}
          disableElevation
          onClick={handleGoNext}
        >
          {t("go_next")}
        </Button>
      </div>

      <CustomErrorDialogBox
        header={t("something_went_wrong")}
        icon={
          <ErrorOutlineOutlinedIcon
            style={{
              color: "#D95959",
              borderRadius: "10px",
              marginTop: "16px",
              width: "80px",
              height: "80px",
            }}
          />
        }
        secondaryButtonText={t("new_student")}
        isDialogOpen={errorDialogOpen}
        showSecondaryButton
        onClickSecondaryButton={() => sendMessageToReactNative("status=2")}
      />
    </div>
  );
}

export default OnBoardingScreen;
